export default __webpack_public_path__ + "static/Comfortaa-Regular-ad1091773d7698e0a9214d7d3f6c112c.woff2";